import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie-service';
import { ApigeeDAO } from './apigee.dao';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { APP_CONFIG } from '../config';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { LogService } from '../services/logging.service';
import { DefaultDataValidator } from './validators';

const CLASS_NAME = 'StayDao';

@Injectable()
export class StayDao extends ApigeeDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.stayDAO, new DefaultRetryHandler(), new DefaultDataValidator(), log, cookieService);
  }

  getStaysInPeriod(searchPeriodStart: string): Observable<any> {
    const url = `${this.daoConfig.url}`;
    return super.doGet(url, { searchPeriodStart });
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/stay.dao.ts